import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService, ModalService } from 'ng-devui';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AlertDialogComponent,
  AlertDialogType,
} from 'src/app/modules/shared/components/alert-dialog/alert-dialog.component';
import {
  TableColumnConfig,
  TableColumnOption,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileFormHeaderFindRequest } from 'src/app/modules/shared/models/archive/archive-file-form-header-find-request.model';
import { ArchiveFileFormHeaderInfo } from 'src/app/modules/shared/models/archive/archive-file-form-header-info.model';
import { ArchiveFileGroupSearchRequest } from 'src/app/modules/shared/models/archive/archive-file-group-search-request.model';
import {
  ArchiveFileStatus,
  ArchiveFileStatusMap,
  ArchiveFileStatusOptions,
} from 'src/app/modules/shared/models/archive/archive-file-status.enum';
import { ArchiveFile } from 'src/app/modules/shared/models/archive/archive-file.model';
import { ArchiveStatus } from 'src/app/modules/shared/models/archive/archive-status.enum';
import { ArchiveVolume } from 'src/app/modules/shared/models/archive/archive-volume.model';
import { FileType } from 'src/app/modules/shared/models/form/file-type.enum';
import { FormHeaderFormat } from 'src/app/modules/shared/models/form/form-header-format.enum';
import { FormHeaderSearch } from 'src/app/modules/shared/models/form/form-header-search.enum';
import { FormHeaderType } from 'src/app/modules/shared/models/form/form-header-type.enum';
import { RecordSource } from 'src/app/modules/shared/models/material/record-source.enum';
import {
  ProjectItemType,
  ProjectItemTypeIndexList,
  ProjectItemTypeShortMap,
} from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { EventService } from 'src/app/modules/shared/providers/event.service';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { FileResponse } from 'src/app/modules/shared/providers/request/file-response.model';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { Page } from 'src/app/modules/shared/providers/request/page.type';
import { ArchiveCatalogService } from 'src/app/modules/shared/services/archive-catalog.service';
import { ArchiveFileFormHeaderService } from 'src/app/modules/shared/services/archive-file-form-header.service';
import { ArchiveFileService } from 'src/app/modules/shared/services/archive-file.service';
import { ArchiveVolumeFileService } from 'src/app/modules/shared/services/archive-volume-file.service';
import { ArchiveVolumeService } from 'src/app/modules/shared/services/archive-volume.service';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { DialogArchiveHeadersComponent } from '../../../dialogs/projects-profiles/dialog-archive-headers/dialog-archive-headers.component';
import { DialogArchiveUploadFillComponent } from '../../../dialogs/projects-profiles/dialog-archive-upload-fill/dialog-archive-upload-fill.component';
import {
  DialogProfilesVolumeUploadComponent,
  ProfilesVolumeUploadResult,
} from '../../../dialogs/projects-profiles/dialog-profiles-volume-upload/dialog-profiles-volume-upload.component';

@Component({
  selector: 'app-projects-profiles-non-wbs',
  templateUrl: './projects-profiles-non-wbs.component.html',
  styleUrls: ['./projects-profiles-non-wbs.component.scss'],
})
export class ProjectsProfilesNonWbsComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  config?: TableConfig = new TableConfig();

  searchRequest = new ArchiveFileGroupSearchRequest();
  recordList: ArchiveFile[] = [];

  currentCheckList: boolean[] = [];

  calcResult = '';

  ProjectItemType = ProjectItemType;

  ProjectItemTypeShortMap = ProjectItemTypeShortMap;

  ProjectItemTypeIndexList = ProjectItemTypeIndexList;

  projectSections: ProjectSection[] = [];

  /**
   * 分页器配置
   * @memberof AdminComponent
   */
  pager = this.globalService.recoverPager();
  timeout: any = undefined;

  totalWidth = 0;
  scrollTop = 0;
  scrollIndex = 0;
  isOpen = true;
  sliceCount = 2;

  root: ArchiveCatalog = new ArchiveCatalog();

  ArchiveFileStatusOptions = ArchiveFileStatusOptions;

  ArchiveFileStatus = ArchiveFileStatus;

  volumeList: ArchiveVolume[] = [];

  volumeMap: { [key: number]: ArchiveVolume } = {};

  volumeSortOrderOpts: TableColumnOption[] = [];

  selectedVolumeList: ArchiveVolume[] = [];

  ArchiveStatus = ArchiveStatus;

  ArchiveFileStatusMap = ArchiveFileStatusMap;

  defaultOrderFields: string[] = [
    'volumeSortOrderOrder',
    'volumeFileSortOrderOrder',
    'codeNameOrder',
    'formSnOrder',
    'finishDateOrder',
    'submitDateOrder',
  ];

  firstSortOrderKey: string = '';

  firstSortOrderKeyChange($event: string) {
    this.firstSortOrderKey = $event;
  }

  editing: { [name: string]: boolean } = {};

  editColumn(name: string) {
    this.editing[name] = true;
  }

  headers: ArchiveFileFormHeaderInfo[] = [];

  FormHeaderSearch = FormHeaderSearch;

  FormHeaderType = FormHeaderType;

  volumeFileSortOrderMap: { [key: number]: TableColumnOption[] } = {};

  readonly = false;

  fileCountMap: { [key: number]: number } = {};

  showNotArchivingFile = true;

  RecordSource = RecordSource;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private archiveFileFormHeaderService: ArchiveFileFormHeaderService,
    private archiveCatalogService: ArchiveCatalogService,
    private archiveFileService: ArchiveFileService,
    private globalService: GlobalService,
    private archiveVolumeFileService: ArchiveVolumeFileService,
    private archiveVolumeService: ArchiveVolumeService,
    private events: EventService,
    private loading: LoadingService,
    private nzMessage: NzMessageService,
    private commonService: CommonService,
  ) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    this.readonly = params.get('readonly') === 'true';
    if (!!this.readonly) {
      this.showNotArchivingFile = false;
    }
  }

  // @HostListener('window:visibilitychange')
  // handleVisibilityChange() {
  //   if (!document.hidden) {
  //     this.searchRecord();
  //   }
  // }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.resize();
    }, 100);
    window.addEventListener('resize', () => {
      this.resize();
    });
  }

  ngOnInit(): void {
    this.prepare();
  }

  onVolumeSelectedChange(volumes: ArchiveVolume[]) {
    this.selectedVolumeList = volumes;
    if (!this.searchRequest.catalogId) {
      this.resetSearch();
    } else {
      this.searchRecord();
    }
  }

  onVolumeListChange(values: ArchiveVolume[]) {
    const volumes = JSON.parse(JSON.stringify(values)) as ArchiveVolume[];
    const sortOrderOptions: TableColumnOption[] = [];
    const sorted = volumes.sort(
      (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0),
    );
    for (const volume of sorted) {
      volume.sortOrderLabel = (volume.sortOrder ?? '')
        .toString()
        .padStart(3, '0');
      sortOrderOptions.push({
        label: volume.sortOrderLabel! + ' ' + volume.title!,
        value: volume.id!,
      });
      this.volumeMap[volume.id!] = volume;
    }
    if (!!this.showNotArchivingFile) {
      sortOrderOptions.push({
        label: '未归卷',
        value: 0,
      });
    }
    this.volumeSortOrderOpts = sortOrderOptions;
    this.volumeList = volumes;
    const fileCountMap: { [key: number]: number } = {};
    for (const volume of volumes) {
      fileCountMap[volume.id!] = volume.fileCount!;
    }
    this.fileCountMap = fileCountMap;
    this.initConfig();
  }

  onShowNotArchivingFileChange() {
    const volumes = JSON.parse(
      JSON.stringify(this.volumeList),
    ) as ArchiveVolume[];
    const sortOrderOptions: TableColumnOption[] = [];
    const sorted = volumes.sort(
      (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0),
    );
    for (const volume of sorted) {
      volume.sortOrderLabel = (volume.sortOrder ?? '')
        .toString()
        .padStart(3, '0');
      sortOrderOptions.push({
        label: volume.sortOrderLabel! + ' ' + volume.title!,
        value: volume.id!,
      });
      this.volumeMap[volume.id!] = volume;
    }
    if (!!this.showNotArchivingFile) {
      sortOrderOptions.push({
        label: '未归卷',
        value: 0,
      });
    }
    this.volumeSortOrderOpts = sortOrderOptions;
    this.initConfig();
    this.searchRecord();
  }

  headerSettings() {
    const results = this.modalService.open({
      component: DialogArchiveHeadersComponent,
      onClose: () => {},
      data: {
        data: this.root,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: (result: ArchiveCatalog) => {
          results.modalInstance.hide();
          this.prepareHeader();
        },
      },
    });
  }

  onFileSynced() {
    this.archiveCatalogService
      .findById(this.activatedRoute.snapshot.params['id'])
      .subscribe((archiveCatalog) => {
        for (const key in archiveCatalog) {
          this.root[key] = archiveCatalog[key];
        }
      });
  }

  private prepare() {
    this.archiveCatalogService
      .findById(this.activatedRoute.snapshot.params['id'])
      .subscribe((archiveCatalog) => {
        this.root = archiveCatalog;
        this.prepareHeader();
      });
  }

  private prepareHeader() {
    this.archiveFileFormHeaderService
      .findOne<ArchiveFileFormHeaderFindRequest>({
        catalogId: this.root.id!,
      })
      .subscribe((res) => {
        const headers = res.formHeaders ?? [];
        const names = headers.map((h) => h.name);
        this.headers = headers.filter(
          (h, index) => !!h.selected && index === names.indexOf(h.name),
        );
        console.log(this.headers);
        this.initConfig();
      });
  }

  private initConfig() {
    const columnsPre: TableColumnConfig[] = [
      {
        name: '卷序',
        key: 'volumeSortOrder',
        type: TableColumnType.options,
        options: this.volumeSortOrderOpts,
        width: 60,
        sortable: true,
        sortKey: 'volumeSortOrderOrder',
        sortOrder: 1,
        sortDefault: OrderType.ASC,
        queryable: true,
        queryKey: 'volumeSortOrder',
      },
      {
        name: '卷内<br>序号',
        key: 'volumeFileSortOrder',
        type: TableColumnType.text,
        width: 50,
        sortable: true,
        sortKey: 'volumeFileSortOrderOrder',
        sortDefault: OrderType.ASC,
      },
      {
        name: '文件题名',
        key: 'fileTitle',
        type: TableColumnType.text,
        width: 200,
        queryable: true,
        queryKey: 'fileTitle',
      },
      // {
      //   name: '表单编号',
      //   key: 'formSn',
      //   type: TableColumnType.text,
      //   width: 120,
      //   queryable: true,
      //   queryKey: 'formSn',
      //   sortable: true,
      //   sortKey: 'formSnOrder',
      //   sortDefault: OrderType.ASC,
      // },
    ];
    const columnsHeaders: TableColumnConfig[] = [];
    for (const h of this.headers ?? []) {
      if (h.fieldName === 'formName') {
        columnsHeaders.push({
          name: '表单名称',
          key: 'codeName',
          type: TableColumnType.text,
          width: h.width!,
          queryable: true,
          queryKey: 'codeName',
          sortable: true,
          sortKey: 'codeNameOrder',
          sortDefault: OrderType.ASC,
          patternStr: 'E+' + h.width,
          align: h.horizontal
            ? (h.horizontal.toLowerCase() as 'left' | 'center' | 'right')
            : 'center',
        });
      } else if (h.fieldName === 'submitDate') {
        columnsHeaders.push({
          name: '提交日期',
          key: 'submitDate',
          type: TableColumnType.date,
          width: h.width!,
          queryable: true,
          queryKey: 'submitDate',
          sortable: true,
          sortKey: 'submitDateOrder',
          sortDefault: OrderType.ASC,
          patternStr: 'E+' + h.width,
          align: h.horizontal
            ? (h.horizontal.toLowerCase() as 'left' | 'center' | 'right')
            : 'center',
        });
      } else if (h.fieldName === 'finishDate') {
        columnsHeaders.push({
          name: '完成日期',
          key: 'finishDate',
          type: TableColumnType.date,
          width: h.width!,
          queryable: true,
          queryKey: 'finishDate',
          sortable: true,
          sortKey: 'finishDateOrder',
          sortDefault: OrderType.ASC,
          patternStr: 'E+' + h.width,
          align: h.horizontal
            ? (h.horizontal.toLowerCase() as 'left' | 'center' | 'right')
            : 'center',
        });
      } else {
        columnsHeaders.push({
          name: h.name!,
          type:
            h.format === FormHeaderFormat.DATE
              ? TableColumnType.date
              : TableColumnType.text,
          queryable: h.search !== FormHeaderSearch.CLOSE,
          queryKey: h.fieldName,
          queryType:
            h.search === FormHeaderSearch.DATE
              ? TableColumnType.date
              : TableColumnType.text,
          width: h.width ?? 100,
          key: h.type === FormHeaderType.FIXED ? h.fieldName! : h.name!,
          patternStr: 'E+' + (h.width ?? 100),
          align: h.horizontal
            ? (h.horizontal.toLowerCase() as 'left' | 'center' | 'right')
            : 'center',
        });
      }
    }

    const columnsEnd: TableColumnConfig[] = [
      {
        name: '文件状态',
        key: 'fileStatus',
        type: TableColumnType.options,
        options: ArchiveFileStatusOptions,
        width: 60,
        queryable: true,
        queryKey: 'fileStatus',
      },
      {
        name: '备注',
        key: 'comment',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'comment',
      },
    ];

    if (!this.readonly) {
      columnsEnd.push({
        name: '操作',
        key: 'action',
        type: TableColumnType.actions,
        width: 100,
      });
    }

    columnsEnd.push({
      name: '主页|附份-页|容量',
      key: 'remark',
      type: TableColumnType.text,
      width: 140,
    });
    const columns = [...columnsPre, ...columnsHeaders, ...columnsEnd];
    this.config = {
      columns,
      headerSize: 12,
      bodySize: 13,
      hideQuery: !this.isOpen,
      freezeColumn: 3,
    };

    this.totalWidth = columns.reduce((acc, cur) => acc + cur.width, 0);
  }

  sign(workFlowKey?: string) {
    if (!workFlowKey) {
      return;
    }
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  ngOnDestroy(): void {
    this.hiddenHost.viewContainerRef.clear();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  onScroll(event: any) {}

  onScrollEnd($event?: any) {}

  searchRecord() {
    this.onFileSynced();
    const volumeIds = this.selectedVolumeList.map((volume) => volume.id!);
    if (!!this.showNotArchivingFile) {
      volumeIds.push(0);
    }
    this.searchRequest.volumeIds = volumeIds;
    if (!!this.searchRequest.volumeSortOrder) {
      if (`${this.searchRequest.volumeSortOrder}` === '0') {
        if (!!this.showNotArchivingFile) {
          this.searchRequest.volumeIds = [0];
        }
      } else if (
        volumeIds.length > 0 &&
        volumeIds.includes(this.searchRequest.volumeSortOrder)
      ) {
        this.searchRequest.volumeIds = [this.searchRequest.volumeSortOrder];
      }
    }
    this.archiveFileService
      .search(this.searchRequest, this.pager.pageIndex - 1, this.pager.pageSize)
      .subscribe((data: Page<ArchiveFile>) => {
        this.globalService.savePager(this.pager);
        this.currentCheckList = [];
        this.hiddenHost.viewContainerRef.clear();
        if (data) {
          this.pager.total = data.totalElements;
          this.recordList = data.content;
          const volumeFileSortOrderMap: { [key: string]: TableColumnOption[] } =
            {};
          for (const file of this.recordList) {
            for (const item of file.extFields ?? []) {
              file[item.title!] = item.value!;
            }
            file.volumeIdTarget = file.volumeId;
            if (file.finishDate) {
              file.finishDateDate = new Date(file.finishDate);
            }
            if (file.submitDate) {
              file.submitDateDate = new Date(file.submitDate);
            }
            if (!!file.volumeId) {
              if (!volumeFileSortOrderMap[file.volumeId]) {
                volumeFileSortOrderMap[file.volumeId] = [];
              }
              volumeFileSortOrderMap[file.volumeId].push({
                label: (+file.volumeFileSortOrder! + 1)!.toString(),
                value: file.volumeFileSortOrder!,
              });
            }
            file.volumeFileSortOrderTarget = file.volumeFileSortOrder;
          }
        }
      });
  }

  rest = 100;

  resize() {
    const ele = document.getElementsByClassName('footer');
    if (ele.length > 0) {
      const footer = ele[0] as HTMLElement;
      const rest = footer.clientWidth - 600 - 240 - 16;
      this.rest = rest;
    }
  }

  checkChange(checks: boolean[]) {
    this.currentCheckList = checks;
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  edit(row: number) {}

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
  }

  remove(row: number) {
    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除',
        content: '确认删除？',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.confirm,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.removeRecord(row);
          results.modalInstance.hide();
        },
      },
    });
  }

  calcResultChange(result: string) {
    this.calcResult = result;
  }

  queryPanelStateChange(isOpen: boolean) {
    console.log(isOpen);
    this.isOpen = isOpen;
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  resetSearch(force?: boolean) {
    this.searchRequest = new ArchiveFileGroupSearchRequest();
    this.searchRequest.projectId = this.globalService.projectId;
    this.searchRequest.catalogId = this.root.id;
    this.pager.pageIndex = 1;
    this.searchRequest.orderedSortFields = this.defaultOrderFields;
    this.searchRequest['volumeSortOrderOrder'] = OrderType.ASC;
    this.searchRequest['volumeFileSortOrderOrder'] = OrderType.ASC;
    this.searchRequest['codeNameOrder'] = OrderType.ASC;
    this.searchRequest['formSnOrder'] = OrderType.ASC;
    this.searchRequest['finishDateOrder'] = OrderType.ASC;
    this.searchRequest['submitDateOrder'] = OrderType.ASC;
    this.searchRecord();
  }

  private prepareSearch(data: any) {
    this.searchRequest = new ArchiveFileGroupSearchRequest();
    this.searchRequest.projectId = this.globalService.projectId;
    this.searchRequest.catalogId = this.root.id;
    this.searchRequest.orderedSortFields = this.defaultOrderFields;
    this.searchRequest['volumeSortOrderOrder'] = OrderType.ASC;
    this.searchRequest['volumeFileSortOrderOrder'] = OrderType.ASC;
    this.searchRequest['codeNameOrder'] = OrderType.ASC;
    this.searchRequest['formSnOrder'] = OrderType.ASC;
    this.searchRequest['finishDateOrder'] = OrderType.ASC;
    this.searchRequest['submitDateOrder'] = OrderType.ASC;
    if (!!this.firstSortOrderKey) {
      for (let i = 0; i < this.searchRequest.orderedSortFields.length; i++) {
        if (
          this.searchRequest.orderedSortFields[i] === this.firstSortOrderKey
        ) {
          this.searchRequest.orderedSortFields.splice(i, 1);
          break;
        }
      }
      this.searchRequest.orderedSortFields.unshift(this.firstSortOrderKey);
    }
    Object.assign(this.searchRequest, data);
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  afterEdit(data: { row: number; key: string }) {
    const { row, key } = data;
    this.editRecord(row);
  }

  batchChangeEnable() {
    let selectCount = 0;
    let selectedIndex = -1;
    const ids: number[] = [];
    for (let i = 0; i < this.currentCheckList.length; i++) {
      if (this.currentCheckList[i]) {
        selectedIndex = i;
        selectCount++;
        ids.push(this.recordList[i].id!);
      }
    }
    if (selectCount === 0) {
      return;
    }

    let content = `选中的${selectCount}个项目`;

    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '启停选中',
        content,
        hint: '批量设置为',
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'primary',
        type: AlertDialogType.option,
        options: [
          {
            value: 1,
            name: '启用',
          },
          {
            value: 0,
            name: '停用',
          },
        ],
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: (result: number) => {
          // this.updateRecordBatched({
          //   idList: ids,
          //   enabled: +result,
          // });
          results.modalInstance.hide();
        },
      },
    });
  }

  moveUp(fileInfo: ArchiveFile) {
    if (
      !fileInfo.volumeId ||
      !fileInfo.volumeFileId ||
      !this.volumeMap[fileInfo.volumeId]
    ) {
      this.nzMessage.error('卷不存在，无法移动');
      return;
    }
    if (this.volumeMap[fileInfo.volumeId].status !== ArchiveStatus.UNLOCK) {
      this.nzMessage.error('卷已锁定，无法移动');
      return;
    }
    this.archiveVolumeFileService
      .moveUp(fileInfo.volumeFileId!)
      .subscribe((res) => {
        this.searchRecord();
      });
  }

  moveDown(fileInfo: ArchiveFile) {
    if (
      !fileInfo.volumeId ||
      !fileInfo.volumeFileId ||
      !this.volumeMap[fileInfo.volumeId]
    ) {
      this.nzMessage.error('卷不存在，无法移动');
      return;
    }
    if (this.volumeMap[fileInfo.volumeId].status !== ArchiveStatus.UNLOCK) {
      this.nzMessage.error('卷已锁定，无法移动');
      return;
    }
    this.archiveVolumeFileService
      .moveDown(fileInfo.volumeFileId!)
      .subscribe((res) => {
        this.searchRecord();
      });
  }

  batchRemove() {
    let selectCount = 0;
    let selectedIndex = -1;
    const ids: number[] = [];
    for (let i = 0; i < this.currentCheckList.length; i++) {
      if (this.currentCheckList[i]) {
        selectedIndex = i;
        selectCount++;
        ids.push(this.recordList[i].id!);
      }
    }
    if (selectCount === 0) {
      return;
    }

    let content = `确认删除选中的${selectCount}个项目`;

    const results = this.modalService.open({
      backdropCloseable: false,
      component: AlertDialogComponent,
      onClose: () => {},
      data: {
        title: '删除选中',
        content,
        cancelBtnText: '取消',
        confirmBtnText: '确认',
        contentStyle: 'danger',
        type: AlertDialogType.prompt,
        onCancel: () => {
          console.log('cancel');
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.removeRecordBatched(ids);
          results.modalInstance.hide();
        },
      },
    });
  }

  onSortOrderChange(data: ArchiveFile) {
    this.archiveFileService
      .update({
        id: data.id,
        volumeId: data.volumeIdTarget,
      })
      .subscribe(() => {
        // this.nzMessage.success('更新成功');
        this.searchRecord();
        this.events.broadcast('volumeListUpdate');
        this.getVolumeFileCount();
      });
  }

  onVolumeFileSortOrderChange(data: ArchiveFile) {
    const volumeFileCount = this.fileCountMap[data.volumeIdTarget!];
    if (+data.volumeFileSortOrderTarget! > +volumeFileCount) {
      this.nzMessage.error('排序号不能大于卷文件数量');
      this.searchRecord();
      return;
    }
    if (+data.volumeFileSortOrderTarget! < 1) {
      this.nzMessage.error('排序号不能小于1');
      this.searchRecord();
      return;
    }

    this.archiveVolumeFileService
      .update({
        id: data.volumeFileId,
        volumeId: data.volumeIdTarget,
        sortOrder: data.volumeFileSortOrderTarget,
        catalogId: data.catalogId,
      })
      .subscribe(() => {
        // this.nzMessage.success('更新成功');
        this.searchRecord();
        this.events.broadcast('volumeListUpdate');
        this.getVolumeFileCount();
      });
  }

  private getVolumeFileCount() {
    this.archiveVolumeService
      .findAll({
        projectId: this.globalService.projectId,
        catalogId: this.root.id,
      })
      .subscribe((res) => {
        const fileCountMap: { [key: number]: number } = {};
        for (const volume of res ?? []) {
          fileCountMap[volume.id!] = volume.fileCount!;
        }
        this.fileCountMap = fileCountMap;
      });
  }

  private removeRecordBatched(ids: number[]) {}

  private removeRecord(index: number) {
    this.archiveFileService.remove(this.recordList[index].id!).subscribe(() => {
      this.nzMessage.success('删除成功');
      this.searchRecord();
      this.events.broadcast('volumeListUpdate');
    });
  }

  private editRecord(index: number) {}

  onFileEdit(file: ArchiveFile) {
    this.editing = {};
    if (file.finishDateDate) {
      file.finishDate = new Date(file.finishDateDate).getTime();
    }
    if (file.submitDateDate) {
      file.submitDate = new Date(file.submitDateDate).getTime();
    }
    this.archiveFileService.update(file).subscribe(() => {
      // this.nzMessage.success('更新成功');
      this.searchRecord();
      this.events.broadcast('volumeListUpdate');
    });
  }

  insertFile(event: any, row: number) {
    const files = event.target['files'];
    console.log(files);
    const record = this.recordList[row];
    this.commonService
      .uploadFileWithoutProgress(files[0])
      .subscribe((url: FileResponse) => {
        const archiveFile = new ArchiveFile();
        archiveFile.fileId = url.fileId;
        archiveFile.projectId = this.globalService.projectId;
        archiveFile.catalogId = this.root.id;
        archiveFile.fileType = FileType.PDF;
        archiveFile.fileName = files[0].name.split('.')[0];
        archiveFile.fileStatus = ArchiveFileStatus.OK;
        archiveFile.prevArchiveFileId = record.id;
        archiveFile.volumeId = record.volumeId;

        event.target['value'] = '';
        const results = this.modalService.open({
          component: DialogArchiveUploadFillComponent,
          onClose: () => {},
          data: {
            data: archiveFile,
            onCancel: () => {
              results.modalInstance.hide();
            },
            onConfirm: () => {
              results.modalInstance.hide();
              // TODO: 重新刷新当前展开的文件列表和volume list
              this.searchRecord();
              this.events.broadcast('volumeListUpdate');
            },
          },
        });
      });
  }

  downloadVolumeTemp() {
    // TODO
    // if (fileName === '') {
    //   fileName = this.workReport.formImportTlFileId ?? '';
    // }
    // const Link = document.createElement('a');
    // const fileUrl = environment.fileHost + this.workReport.formImportTlFileId!;
    // downloadLink.href = fileUrl;
    // downloadLink.target = '_blank';
    // downloadLink.download =
    //   fileName ?? this.workReport.formImportTlFileId ?? '';
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // this.commonService
    //   .download(this.workReport.formImportTlFileId ?? '', fileName)
    //   .subscribe((res) => {
    //     const blob = new Blob([res], {
    //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //     });
    //     const url = window.URL.createObjectURL(blob);
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = url;
    //     downloadLink.download = fileName;
    //     document.body.appendChild(downloadLink);
    //     downloadLink.click();
    //   });
  }

  uploadOfflineVolume() {
    const results = this.modalService.open({
      component: DialogProfilesVolumeUploadComponent,
      onClose: () => {},
      data: {
        data: this.root,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: (result: ProfilesVolumeUploadResult) => {
          results.modalInstance.hide();
          // TODO:
          // this.searchRecord();
          // this.events.broadcast('volumeListUpdate');
        },
      },
    });
  }
}
